import PitchResult from "../enums/PitchResult.js";

const classifiesAsHitByPitch = function(taggedPitchResultKey){
    return taggedPitchResultKey === PitchResult.HitByPitch.key;
};

export default classifiesAsHitByPitch;